import * as React from "react";
import { inject, observer } from "mobx-react";
import { SponsoredContentMarqueeProps } from "./typings";
import SponsoredContentSlot from "components/flexComponents/SponsoredContentRenderer/slot";

export const SponsoredContentMarquee = inject("advertising")(
  observer(({ advertising, sponsoredContentId }: SponsoredContentMarqueeProps) => {
    if (!advertising || !advertising.includeAdLoader) {
      return null;
    }

    return <SponsoredContentSlot sci={sponsoredContentId || "NMT"} classes="SponsoredContentMarquee" />;
  })
);

export default SponsoredContentMarquee;
